import App from "./App.svelte";

const app = new App({
  // target: document.body
  target: document.getElementById("content"),
});

export default app;
